import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";
import "./style/main.scss";
import { Provider } from "react-redux";
import { store } from "./store/store.ts";

const alwaysReport = false;

const config = {
  production: import.meta.env.PROD,
  development: import.meta.env.DEV,
  localHost:
    window.location.hostname === "localhost" ||
    window.location.hostname === process.env.DEV_HOST,
};

// if ((config.production && !config.localHost) || alwaysReport) {
//   Sentry.init({
//     dsn: "https://4d7995ca59bd05fdbb2fcdfa4333be23@o1077038.ingest.sentry.io/4506030873378816",
//     integrations: [Sentry.browserTracingIntegration()],
//     // Performance Monitoring
//     tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   });
// }

/**
 * Strict mode causes the App to render twice. This is only an issue in dev mode
 * because it does some extra checks.
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
